import React, { useCallback, useState } from 'react'

import {
  Box,
  Heading1,
  Body3,
  Display,
  JustifyContent,
  Color,
  Button,
  ButtonSize,
  ButtonColorVariant,
} from '@gousto-internal/citrus-react'

import { PauseReasons } from './PauseReasons'

interface Props {
  isContinueToPauseEnabled: boolean
  handleBackButton: () => void
  handleContinueToPauseButton: () => void
}

const SubscriptionPauseReasonOSR = ({
  isContinueToPauseEnabled,
  handleBackButton,
  handleContinueToPauseButton,
}: Props) => {
  const [continueButtonEnabled, setContinueButtonEnabled] = useState(isContinueToPauseEnabled)
  const handleSelectedReason = useCallback(() => {
    setContinueButtonEnabled(true)
  }, [setContinueButtonEnabled])

  return (
    <Box display={Display.Flex} justifyContent={JustifyContent.Center} paddingV={6}>
      <Box
        width="60%"
        bg={Color.White}
        paddingH={10}
        paddingV={10}
        data-testing="SubscriptionPauseReasonOSR-section"
      >
        <Box data-testing="SubscriptionPauseReasonOSR-heading">
          <Body3 color={Color.ColdGrey_600}>Pause subscription</Body3>
          <Heading1 color={Color.ColdGrey_900}>Before pausing, can you tell us why?</Heading1>
          <Body3 color={Color.ColdGrey_800}>
            Telling us why will help us make it better in the future.
          </Body3>
        </Box>
        <Box paddingV={10}>
          <PauseReasons handleSelectedReason={handleSelectedReason} />
        </Box>
        <Box
          data-testing="SubscriptionPauseReasonOSR-footer"
          display={Display.Flex}
          justifyContent={JustifyContent.SpaceBetween}
        >
          <Button
            colorVariant={ButtonColorVariant.Secondary}
            size={ButtonSize.Large}
            onClick={handleBackButton}
            data-testing="SubscriptionPauseReasonOSR-back-button"
          >
            Back
          </Button>
          <Button
            colorVariant={ButtonColorVariant.Primary}
            size={ButtonSize.Large}
            disabled={!continueButtonEnabled}
            onClick={handleContinueToPauseButton}
            data-testing="SubscriptionPauseReasonOSR-continueToPause-button"
          >
            Continue to pause
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export { SubscriptionPauseReasonOSR }
